/* eslint-disable */
var VjsUtility = window.VjsUtility;

// not sure why we're afraid this native function does not exist
// but was afraid to remove it
if (!String.prototype.startsWith) {
    // eslint-disable-next-line no-extend-native
    String.prototype.startsWith = function (searchString, pos) {
        const position = pos || 0;

        return this.indexOf(searchString, position) === position;
    };
}

/* console shim */
(function () {
    const f = function () {
        //
    };
    if (!window.console) {
        window.console = {
            log: f,
            info: f,
            warn: f,
            debug: f,
            error: f,
        };
    }
}());

const Base64 = {
    keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    encode(str) {
        let t = '';
        let n;
        let r;
        let i;
        let s;
        let o;
        let u;
        let a;
        let f = 0;
        const e = Base64.utf8Encode(str);
        while (f < e.length) {
            n = e.charCodeAt(f++);
            r = e.charCodeAt(f++);
            i = e.charCodeAt(f++);
            s = n >> 2;
            o = ((n & 3) << 4) | (r >> 4);
            u = ((r & 15) << 2) | (i >> 6);
            a = i & 63;
            if (Number.isNaN(r)) {
                u = 64;
                a = 64;
            } else if (Number.isNaN(i)) {
                a = 64;
            }
            t = t + this.keyStr.charAt(s) + this.keyStr.charAt(o) + this.keyStr.charAt(u) + this.keyStr.charAt(a);
        }
        return t;
    },
    decode(str) {
        let t = '';
        let n;
        let r;
        let i;
        let s;
        let o;
        let u;
        let a;
        let f = 0;
        const e = str.replace(/[^A-Za-z0-9+/=]/g, '');
        while (f < e.length) {
            s = this.keyStr.indexOf(e.charAt(f++));
            o = this.keyStr.indexOf(e.charAt(f++));
            u = this.keyStr.indexOf(e.charAt(f++));
            a = this.keyStr.indexOf(e.charAt(f++));
            n = (s << 2) | (o >> 4);
            r = ((o & 15) << 4) | (u >> 2);
            i = ((u & 3) << 6) | a;
            t += String.fromCharCode(n);
            if (+u !== 64) {
                t += String.fromCharCode(r);
            }
            if (+a !== 64) {
                t += String.fromCharCode(i);
            }
        }
        t = Base64.utf8Decode(t);
        return t;
    },
    utf8Encode(str) {
        const e = str.replace(/rn/g, 'n');
        let t = '';
        for (let n = 0; n < e.length; n++) {
            const r = e.charCodeAt(n);
            if (r < 128) {
                t += String.fromCharCode(r);
            } else if (r > 127 && r < 2048) {
                t += String.fromCharCode((r >> 6) | 192);
                t += String.fromCharCode((r & 63) | 128);
            } else {
                t += String.fromCharCode((r >> 12) | 224);
                t += String.fromCharCode(((r >> 6) & 63) | 128);
                t += String.fromCharCode((r & 63) | 128);
            }
        }
        return t;
    },
    utf8Decode(e) {
        let t = '';
        let n = 0;
        let r = 0;
        let c2 = 0;
        let c3 = 0;
        while (n < e.length) {
            r = e.charCodeAt(n);
            if (r < 128) {
                t += String.fromCharCode(r);
                n++;
            } else if (r > 191 && r < 224) {
                c2 = e.charCodeAt(n + 1);
                t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
                n += 2;
            } else {
                c2 = e.charCodeAt(n + 1);
                c3 = e.charCodeAt(n + 2);
                t += String.fromCharCode(((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                n += 3;
            }
        }
        return t;
    },
};

// eslint-disable-next-line prefer-const
let Jr = (function (jr) {
    let initialized = false;

    const assetsRoot = $('meta[property="assets_root"]').attr('content');
    const staticImagesPath = $('meta[property="static_images_path"]').attr('content');
    const csrfToken = $('meta[property="csrf_token"]').attr('content');
    const siteMode = $('meta[property="site_mode"]').attr('content');

    const userSettings = JSON.parse(Base64.decode($('meta[property="user_settings"]').attr('content')));
    const licenseSettings = JSON.parse(Base64.decode($('meta[property="license_settings"]').attr('content')));

    let transitionEndEvent = null;
    let isPageBeingRefreshed = false;

    VjsUtility.Notification.addHook((text, time, type) => {
        const notificationStack = new PNotify.Stack({
            dir1: 'up',
        });

        const notificationOptions = {
            addClass: 'stack-custom stack-modal',
            styling: 'material',
            minHeight: '100px',
            closer: true,
            stack: notificationStack,
            sticker: false,
            mouseReset: true,
            modules: new Map([
                ...PNotify.defaultModules,
                [
                    PNotifyAnimate,
                    {
                        inClass: 'bounceInLeft',
                        outClass: 'bounceOutRight',
                    },
                ],
                [
                    PNotifyFontAwesome4,
                    {
                        prefix: 'fontawesome4',
                        notice: 'fa fa-exclamation-circle',
                        info: 'fa fa-info-circle',
                        success: 'fa fa-check-circle',
                        error: 'fa fa-exclamation-triangle',
                        closer: 'fa fa-times',
                        sticker: 'fa',
                        stuck: 'fa-play',
                        unstuck: 'fa-pause',
                        refresh: 'fa fa-refresh',
                    },
                ],
            ]),

            text,
            type,
            delay: 3000,
            title: (function (titleType) {
                switch (titleType) {
                    case 'success':
                        return 'Success';
                    case 'error':
                        return 'Error';
                    case 'info':
                        return 'Alert';
                    case 'warning':
                        return 'Warning';
                    default:
                        return 'Alert';
                }
            }(type)),
        };

        PNotify.alert(notificationOptions);
        document.querySelectorAll('.pnotify[role="alertdialog"]:not([aria-label])').forEach((el) => {
            el.setAttribute('aria-label', notificationOptions.title);
        });
    });

    jr.init = function () {
        if (initialized) {
            return;
        }
        initialized = true;

        /**
            Automatically add the CSRF Token (taken from the header meta tag) to all ajax requests
        * */
        $.ajaxPrefilter((options) => {
            /* eslint-disable no-param-reassign */
            if (options.type.toLowerCase() === 'post' || options.type.toLowerCase() === 'put' || options.type.toLowerCase() === 'delete') {
                if (typeof options.data === 'undefined') {
                    options.data = `csrf_token=${jr.getCsrfToken()}`;
                } else {
                    options.data += `&csrf_token=${jr.getCsrfToken()}`;
                    if (options.data.charAt(0) === '&') {
                        options.data = options.data.substr(1);
                    }
                }
            }
            /* eslint-enable no-param-reassign */
        });

        $(window).on('beforeunload', () => {
            isPageBeingRefreshed = true;
        });

        window.onerror = function (message, url, linenumber, columnnumber, error) {
            if (!isPageBeingRefreshed) {
                if (error != null && +linenumber !== 0) {
                    // Error tracking removed
                }
                if (siteMode === 'development') {
                    console.log('Javascript Error:', message, url, linenumber, columnnumber, error);
                }
            } else {
                console.log('page is being refreshed!! Supressing errors!');
            }
        };

        $(document).ajaxError((event, jqxhr, settings, thrownError) => {
            if (!isPageBeingRefreshed) {
                if (thrownError !== 'abort') {
                    // AJAX error tracking removed
                    if (siteMode === 'development') {
                        console.log(`AJAX ERROR: ${thrownError}`, event, jqxhr, settings);
                    }
                }
            } else {
                console.log('page is being refreshed!! Supressing AJAX errors!');
            }
        });

        const fakeElement = document.createElement('fake');
        const transEndEventNames = {
            WebkitTransition: 'webkitTransitionEnd', // Saf 6, Android Browser
            MozTransition: 'transitionend', // only for FF < 15
            transition: 'transitionend', // IE10, Opera, Chrome, FF 15+, Saf 7+
        };

        // eslint-disable-next-line no-restricted-syntax
        for (const t in transEndEventNames) {
            if (fakeElement.style[t] !== undefined) {
                transitionEndEvent = transEndEventNames[t];
            }
        }

        $('time[data-date-format]').each(function () {
            const el = $(this);
            const utcDatetime = el.attr('data-utc-datetime');
            const dateFormat = el.attr('data-date-format');
            if (utcDatetime) {
                const dt = moment.utc(utcDatetime).tz(moment.tz.guess());
                if (dateFormat === 'timeago') {
                    el.text(dt.fromNow());
                } else {
                    el.text(dt.format(dateFormat));
                }
            }
        });

        const $header = $('.navbar-autohide');
        let scrolling = false;
        let previousTop = 0;
        const scrollDelta = 10;
        const scrollOffset = 150;

        $(window).on('scroll', () => {
            if (!scrolling) {
                scrolling = true;

                if (!window.requestAnimationFrame) {
                    setTimeout(autoHideHeader, 250);
                } else {
                    requestAnimationFrame(autoHideHeader);
                }
            }
        });

        function autoHideHeader() {
            const currentTop = $(window).scrollTop();

            // Scrolling up
            if (previousTop - currentTop > scrollDelta) {
                $header.removeClass('is-hidden');
            } else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
                // Scrolling down
                $header.addClass('is-hidden');
            }

            previousTop = currentTop;
            scrolling = false;
        }

        function queryParameters() {
            const result = {};
            const params = window.location.search.split(/\?|&/);
            params.forEach((it) => {
                if (it) {
                    const param = it.split('=');
                    // eslint-disable-next-line prefer-destructuring
                    result[param[0]] = param[1];
                }
            });

            return result;
        }

        // load tracking data from cookie
        let trackingDataJson = Cookies.get('tracking_data');
        let trackingData = {};

        // if it exists, parse it from JSON string to an object
        if (typeof trackingDataJson !== 'undefined') {
            trackingData = JSON.parse(trackingDataJson);
        }

        // check url for query parameters containing 'utm_', save them in a cookie
        if (window.location.search.indexOf('utm_') >= 0) {
            const now = new Date();
            const landingPage = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
            const queryParams = queryParameters();
            trackingData[now.toString()] = queryParams;
            trackingData[now.toString()].landing_page = landingPage;
            trackingDataJson = JSON.stringify(trackingData);
            Cookies.set('tracking_data', JSON.stringify(trackingData), { expires: 30 });
        }

        $('.infield-label').each(function () {
            const nodeName = $(this).prop('nodeName');

            /* wrap field with a container that has position:relative */
            $(this).wrap(`<div class="infield-label-wrap type-${nodeName.toLowerCase()}"></div>`);

            /* Create a label element with correct 'for' and label text from
                id and placeholder, respectively */
            const $label = $('<label>').attr('for', $(this).attr('id')).text($(this).attr('placeholder'));
            $(this).before($label);

            /* remove the placeholder attribute */
            $(this).attr('placeholder', '');

            /* When input changes, add 'focused' class */
            $(this).on('change', function () {
                $(this).siblings('label').addClass('focused');
            });

            /* When field gets focus, add 'focused' class */
            $(this).focus(function () {
                $(this).siblings('label').addClass('focused');
            });

            /* When field loses focus, remove 'focused' class,
               butt only if the field is empty */
            $(this).blur(function () {
                const type = $(this).prop('nodeName');
                const value = type === 'SELECT' ? $(this).find(':selected').val() : $(this).val();

                if (value === '') {
                    $(this).siblings('label').removeClass('focused');
                } else {
                    $(this).siblings('label').addClass('focused');
                }
            });

            const type = $(this).prop('nodeName');
            const value = type === 'SELECT' ? $(this).find(':selected').val() : $(this).val();

            if (value === '') {
                $(this).siblings('label').removeClass('focused');
            } else {
                $(this).siblings('label').addClass('focused');
            }
        });

        $(document).keydown((e) => {
            if (+e.keyCode === 73 && e.ctrlKey) {
                // $('.segment-control').toggle();
                $('body').toggleClass('admin-controls');
                $('.nav-blip').toggleClass('admin-enabled');
            }
        });

        if ($('#report-toolbar').length) {
            $('#report-toolbar').on('click', '#export-report', function (event) {
                event.preventDefault();

                const queryParams = {};

                if ($('#license-filter').length) {
                    queryParams.license_id = $('#license-filter').val();
                }

                if ($('#user-groups').length) {
                    queryParams.group_ids = $.makeArray($('#user-groups option:selected').map((a, item) => item.value));
                }

                if ($('#user-grades').length) {
                    queryParams.grade = $.makeArray($('#user-grades option:selected').map((a, item) => item.value));
                }

                // pass the timezone from the browser to use in formatting dates for exports
                queryParams.browser_timezone = moment.tz.guess();

                const queryString = $.param(queryParams);

                window.open(`${$(this).attr('href')}?${queryString}`, '_blank');
            });
        }

        if ($('body').length > 1) {
            // Multiple body tags error tracking removed

            if (siteMode === 'development') {
                window.alert(
                    'Whoops! An unexpected error has occurred. The developers have been notified. Please refresh the page and try again.',
                );
            }
        }

        if ($('#json_notifications').length) {
            const json = $('#json_notifications').attr('data-notifications');
            const notifications = $.parseJSON($('<textarea/>').html(json).text());

            // eslint-disable-next-line no-restricted-syntax
            for (const notificationType in notifications) {
                if (notifications.hasOwnProperty(notificationType) && $.inArray(notificationType, ['error', 'success', 'info']) !== -1) {
                    const notificationParams = {
                        text: notifications[notificationType],
                        time: 3000,
                        type: notificationType,
                    };
                    VjsUtility.Notification.init(notificationParams);

                    if (notificationType === 'error') {
                        // Error tracking removed
                        $('.pnotify').addClass('animated tada');
                        setTimeout(() => {
                            $('.pnotify').removeClass('animated tada');
                        }, 1000);
                    }
                }
            }
        }

        $('body').on('click', '.click-reveal', function (e) {
            e.preventDefault();
            $(this).replaceWith($('<span>').text($(this).attr('data-value')));
        });

        // Top-right nav menu — manual open/close. BS3 fired
        // show.bs.dropdown / hide.bs.dropdown on the .dropdown container,
        // which we hooked to drive the GSAP expand animation + overlay.
        // BS4 fires those events on the toggle element and its dropdown
        // state machine is less forgiving of the custom markup here,
        // so we bypass it entirely and manage open/close ourselves.
        function openNavMenu() {
            const navMenu = $('#nav-menu');
            const mainBody = $('#main-body');
            const contentContainer = $('#content-container');
            const menuIcon = $('#menu-trigger').find('i');

            if (!$('#overlay').length) {
                $('body').append('<div id="overlay"></div>');
            }

            navMenu.addClass('open');
            gsap.fromTo(navMenu, { height: '3.5em' }, { height: 'auto', duration: 0.5 });
            $('#overlay').fadeIn();
            contentContainer.addClass('blur');
            mainBody.addClass('blur');
            menuIcon.removeClass('fa-bars').addClass('fa-times');
        }

        function closeNavMenu() {
            const navMenu = $('#nav-menu');
            const mainBody = $('#main-body');
            const contentContainer = $('#content-container');
            const menuIcon = $('#menu-trigger').find('i');

            navMenu.removeClass('open');
            gsap.to(navMenu, { height: '3.5em', duration: 0.5 });
            $('#overlay').fadeOut();
            contentContainer.removeClass('blur');
            mainBody.removeClass('blur');
            menuIcon.removeClass('fa-times').addClass('fa-bars');
        }

        $('#visible-menu').on('click', (e) => {
            e.stopPropagation();
            if ($('#nav-menu').hasClass('open')) {
                closeNavMenu();
            } else {
                openNavMenu();
            }
        });

        $('body').on('click', '#overlay', () => {
            closeNavMenu();
        });
    };

    jr.initMe = function (children) {
        // make sure Jr. is initialized first
        if (!initialized) {
            jr.init();
        }

        // if children is an array, init each child
        if (Array.isArray(children)) {
            $.each(children, (i, child) => {
                if (typeof child.init === 'function') {
                    child.init();
                }
            });
        } else if (typeof children === 'object') {
            const child = children;
            if (typeof child.init === 'function') {
                child.init();
            }
        }

        setTimeout(() => {
            $('head').addClass('vjsTestingJsLoaded');
        }, 300);
    };

    jr.getAssetsRoot = function () {
        return assetsRoot;
    };

    jr.getStaticImagesPath = function () {
        return staticImagesPath;
    };

    jr.getCsrfToken = function () {
        return csrfToken;
    };

    jr.getCurrentUserRoleId = function () {
        return userSettings.role_id;
    };

    jr.getCurrentUserId = function () {
        return userSettings.user_id;
    };

    jr.getSSOUserTypeId = function () {
        return licenseSettings.sso_users_type_id;
    };

    jr.getTrackerDetails = function () {
        let contactId = userSettings.user_id;
        if (userSettings.role_id > 2 && userSettings.email !== '' && userSettings !== null) {
            contactId = userSettings.email;
        }
        return {
            organizationAccountId: userSettings.organization_account_id,
            contactId,
        };
    };

    jr.getSSOAdminTypeId = function () {
        return licenseSettings.sso_admins_type_id;
    };

    jr.getLicenseSetting = function (settingName) {
        if (typeof licenseSettings[settingName] !== 'undefined') {
            return licenseSettings[settingName];
        }
        return null;
    };

    jr.getTransitionEndEvent = function () {
        return transitionEndEvent;
    };

    return jr;
}(Jr || {}));

// Resolve a dotted path like "Postlogin.Admin.Lessons" against the window object.
function resolveModulePath(path) {
    return path.split('.').reduce((obj, key) => (obj == null ? obj : obj[key]), window);
}

$(document).ready(() => {
    Jr.init();

    const initModules = document.body.getAttribute('data-init-modules');
    if (initModules) {
        const modules = initModules
            .split(',')
            .map((name) => name.trim())
            .filter((name) => name.length > 0)
            .map(resolveModulePath)
            .filter((mod) => mod != null);
        Jr.initMe(modules);
    } else if (typeof loadMe === 'function') {
        // Back-compat for any template still using inline loadMe().
        // eslint-disable-next-line no-undef
        loadMe();
    }
});

/**
 * ChildNode.prepend() polyfill
 * Adapted from https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/prepend()/prepend().md
 * @author Chris Ferdinandi
 * @license MIT
 */
(function (elem) {
    // Check if element is a node
    // https://github.com/Financial-Times/polyfill-service
    const isNode = function (object) {
        // DOM, Level2
        if (typeof Node === 'function') {
            return object instanceof Node;
        }

        // Older browsers, check if it looks like a Node instance)
        return object && typeof object === 'object' && object.nodeName && object.nodeType >= 1 && object.nodeType <= 12;
    };

    // Add append() method to prototype
    for (let i = 0; i < elem.length; i++) {
        if (!window[elem[i]] || 'prepend' in window[elem[i]].prototype) continue;
        window[elem[i]].prototype.prepend = function () {
            const argArr = Array.prototype.slice.call(arguments);
            const docFrag = document.createDocumentFragment();

            for (let n = 0; n < argArr.length; n++) {
                docFrag.appendChild(isNode(argArr[n]) ? argArr[n] : document.createTextNode(String(argArr[n])));
            }

            this.appendChild(docFrag);
        };
    }
}(['Element', 'CharacterData', 'DocumentType']));
